interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <nav aria-label="分页导航" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-10 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors enabled:hover:border-primary-300 enabled:hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`flex h-10 w-10 items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex h-10 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors enabled:hover:border-primary-300 enabled:hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}